import { useEffect, useCallback } from "react";
import {
  getCustomerLoginAs,
  setNewCustomerId,
  updateLoginAsCustomer,
} from "../../store/slices/CustomerSlice/CustomerSlice";
import { useDispatch, useSelector } from "react-redux";
import AutoComplete from "../atoms/AutoComplete";
import SmallSpinner from "../atoms/Loaders/SmallSpinner";

export function LoginAs({ className }) {
  const dispatch = useDispatch();
  const { currentCustomerId, loginOptions, newCustomerId, pending } =
    useSelector((state) => state.customer);

  const handleSwapCustomer = () => {
    if (currentCustomerId.id !== newCustomerId.id) {
      dispatch(updateLoginAsCustomer()).then(() => {
        window.location.reload();
      });
    }
  };

  const handleSelectNew = (option) => {
    dispatch(setNewCustomerId(option));
  };

  useEffect(() => {
    dispatch(getCustomerLoginAs());
  }, [dispatch]);

  const labelFunction = useCallback((option) => {
    return `${option.id} - ${option.label}`;
  }, []);

  return (
    <div className={"w-full py-5 px-10 flex  justify-end " + className}>
      <div className="flex flex-col items-center gap-3 flex-wrap">
        <div className="font-semibold text-lg flex gap-2">
          Customer:{" "}
          <p className="font-normal">
            {currentCustomerId.id ? (
              labelFunction(currentCustomerId)
            ) : (
              <SmallSpinner show className="text-gray-400" />
            )}
          </p>
        </div>
        {loginOptions.length > 0 && (
          <div>
            <AutoComplete
              selected={currentCustomerId}
              options={loginOptions}
              labelFunction={labelFunction}
              onSelect={handleSelectNew}
            />
          </div>
        )}
        {loginOptions.length > 0 && (
          <div>
            {pending ? (
              <SmallSpinner show={true} />
            ) : (
              <button
                type="button"
                onClick={handleSwapCustomer}
                disabled={newCustomerId.id === currentCustomerId.id}
                className="block rounded-md bg-[var(--primary-color)] px-3 py-2 text-center text-sm font-semibold hover:bg-[var(--secondary-color)] text-white shadow-sm hover:secondary-color focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:primary-color disabled:bg-gray-500"
              >
                Load Customer
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
